import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES, EVENT } from "../data/site";

const openingHours = [
  { days: "Maandag – Donderdag", hours: "13:00u – 00:00u" },
  { days: "Vrijdag – Zaterdag", hours: "13:00u – 01:00u / 02:00u" },
  { days: "Zondag", hours: "13:00u – 00:00u" },
];

export default function Openingsuren() {
  return (
    <>
      <Seo
        title="Openingsuren | Mechelen Beach 2026"
        description={`Mechelen Beach vindt plaats van donderdag 16/07/2026 t.e.m. zondag 09/08/2026. Bekijk hier alle openingsuren.`}
      />

      <PageHero
        eyebrow="Praktische info"
        title="Openingsuren"
        subtitle={`Mechelen Beach vindt plaats van donderdag ${EVENT.startDate} t.e.m. zondag ${EVENT.endDate}.`}
        image={IMAGES.strandbarTable}
        imageAlt="Strandbar Mechelen Beach"
        primaryCta={{ label: "Bekijk programma", to: "/programma" }}
        secondaryCta={{ label: "Bereikbaarheid", to: "/praktische-info/bereikbaarheid" }}
      />

      <section className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Editie 2026</span>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
            Openingsuren per dag
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#6b5945] leading-relaxed">
            Bekijk hieronder de openingsuren voor elke dag van Mechelen Beach 2026.
          </p>

          <div className="mt-8 bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/pr1kbp8d_Mechelen_Beach_Openingsuren_2026_resized.png"
              alt="Openingsuren Mechelen Beach 2026 — overzicht per dag"
              loading="lazy"
              data-testid="opening-hours-image"
              className="w-full h-auto object-contain"
            />
          </div>

          <div
            data-testid="opening-summary-card"
            className="mt-10 bg-white rounded-2xl border border-[#ebd9b5] p-6 sm:p-10 shadow-[0_14px_36px_-18px_rgba(43,28,16,0.25)]"
          >
            <span className="eyebrow">Editie 2026</span>
            <h3 className="font-display mt-4 text-2xl sm:text-3xl font-semibold tracking-tight text-[#2b1c10]">
              Wanneer open?
            </h3>
            <p className="mt-4 text-base sm:text-lg text-[#6b5945] leading-relaxed">
              Mechelen Beach vindt plaats van{" "}
              <span className="font-semibold text-[#2b1c10]">
                donderdag {EVENT.startDate} t.e.m. zondag {EVENT.endDate}
              </span>
              . Onderstaande openingsuren gelden gedurende het volledige evenement.
            </p>

            <div className="mt-6 divide-y divide-[#ebd9b5]">
              {openingHours.map((row, i) => (
                <div
                  key={row.days}
                  data-testid={`opening-row-${i}`}
                  className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-3 py-4"
                >
                  <span className="font-semibold text-sm sm:text-base text-[#2b1c10]">{row.days}</span>
                  <span className="font-display text-base sm:text-lg text-orange-gradient font-semibold">
                    {row.hours}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/praktische-info/menukaart" data-testid="opening-cta-menu" className="btn-primary">
              Bekijk de drankkaart
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/praktische-info/bereikbaarheid"
              data-testid="opening-cta-bereik"
              className="btn-ghost"
            >
              Bereikbaarheid
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
